export default "__VITE_ASSET__CpSw6$yb__"